import { createFileRoute } from "@tanstack/react-router";

import { CalKillerDashboard } from "../tools/dashboards/CalKillerDashboard";

function CalKillerRoute() {
  return <CalKillerDashboard />;
}

export const Route = createFileRoute("/_app/dashboards/cal-killer")({
  component: CalKillerRoute,
});
